<div class="reale-theme-style2 fs-6" fxLayout="column">
  <div fxLayout="column" class="wrapper">
    <header [configuration]="headerConfiguration"></header>
    <app-title [data]="titleData"></app-title>
  </div>

  <div class="components-container">
    <div class="landing-title" fxLayout="column" fxLayoutAlign="center start">
      <div class="title">{{data.brand}}&nbsp;{{data.model}}</div>
      <div class="subtitle">{{data.category}}</div>
    </div>

    <div class="white-card" fxLayout="column" fxLayoutAlign="center start">
      <div class="field" fxLayout="column" fxLayoutAlign="center start">
        <div class="title">{{'landing.price' | translate}}</div>
        <div class="subtitle">{{data.productPrice | currency: 0 : '€' }}</div>
      </div>
      <div class="field" fxLayout="column" fxLayoutAlign="center start">
        <div class="title">{{'landing.date' | translate}}</div>
        <div class="subtitle">{{data.purchaseDate}}</div>
      </div>
    </div>

    <div class="title">{{'landing.coverageTitle' | translate}}</div>
    <div class="coverages white-card">
      <app-coverages-drop-downs [isReadOnly]="true" [coveragesData]="data.coverages" [proxyEnabled]="proxy_enabled"></app-coverages-drop-downs>
    </div>
  
    <div class="title" fxLayout="row" fxLayoutAlign="space-between center" (click)="toggle()" style="cursor: pointer;">
      {{'landing.personalDataTitle' | translate}}
      <mat-icon *ngIf="hiddenPersonalData">expand_more</mat-icon> 
      <mat-icon *ngIf="!hiddenPersonalData">expand_less</mat-icon>
    </div>
    <div class="white-card" [hidden]="hiddenPersonalData">
      <div *ngIf="data.personalData.name" class="field">
        <div class="title">{{'landing.personalDataTitles.name' | translate}}</div>
        <div class="subtitle">{{data.personalData.name}}</div>
      </div>
      <div *ngIf="data.personalData.surname" class="field">
        <div class="title">{{'landing.personalDataTitles.surname' | translate}}</div>
        <div class="subtitle">{{data.personalData.surname}}</div>
      </div>
      <div *ngIf="data.personalData.nif" class="field">
        <div class="title">{{'landing.personalDataTitles.nif' | translate}}</div>
        <div class="subtitle">{{data.personalData.nif}}</div>
      </div>
      <div *ngIf="data.personalData.phone" class="field">
        <div class="title">{{'landing.personalDataTitles.phone' | translate}}</div>
        <div class="subtitle">{{data.personalData.phone}}</div>
      </div>
      <div *ngIf="data.personalData.email" class="field">
        <div class="title">{{'landing.personalDataTitles.email' | translate}}</div>
        <div class="subtitle">{{data.personalData.email}}</div>
      </div>
      <div *ngIf="data.personalData.address" class="field">
        <div class="title">{{'landing.personalDataTitles.address' | translate}}</div>
        <div class="subtitle">{{data.personalData.address}}</div>
      </div>
      <div *ngIf="data.personalData.postalCode" class="field">
        <div class="title">{{'landing.personalDataTitles.postalCode' | translate}}</div>
        <div class="subtitle">{{data.personalData.postalCode}}</div>
      </div>
    </div>

    <div class="title">{{'landing.consentsTitle' | translate}}</div>
    <div class="" *ngIf="data.productId">
      <app-consents [productID]="data.productId" [personaID]="data.idPersona" [proxy]="proxy_enabled" (emitConsent)="getAcceptedConsents($event)"></app-consents>

    </div>
    <div *ngIf="showInvoiceAlert" class="alert-container">
      <p>{{ 'landing.alerInvoiceText' | translate }}</p>
    </div>

    <div fxLayout="row" fxLayoutAlign="center center">
      <button [ngClass]="contractButtonEnabled ? 'contract-button' : 'contract-button-disabled'" 
      [disabled]="!contractButtonEnabled" 
      class="contract-button"
      (click)="acceptConsents()">{{'landing.contractButton' | translate}}</button>
    </div>
  </div>
</div>
